'use client';

import React, { useCallback } from 'react';
import { FloatingActionButton } from '@/components/ui';
import { IconEdit } from '@repo/svgs';
import { useRouter } from 'next/navigation';
import { useAnalytics } from '@/hooks/useAnalytics';

export function ReviewFloatingActionButton() {
  const router = useRouter();
  const analytics = useAnalytics();

  const handleClick = () => {
    analytics.track('landing_write_review');
    router.push(`/review`);
  };

  return (
    <FloatingActionButton
      label="Review your building"
      // bottomOffset={32}
      icon={<IconEdit className="w-4 h-4 icon-inverted" />}
      onClick={handleClick}
      alignment="center"
      aria-label="Review your building"
    />
  );
}

export default ReviewFloatingActionButton;
